import { lazy, Suspense, useState } from 'react';
import { Button } from 'antd';
import clsx from 'clsx';
import { useAppSelector } from 'app/hooks';
import Spin from 'components/Spin';
import If from 'components/If';
import { selectIsEligibleForFinishAccountSetup } from 'services/ctp/ctpSelectors';
import { QaCreditCardCapture } from 'testdata/constants';
import styles from './index.module.scss';

const FinishAccountSetupModal = lazy(
  () => import('pages/finish-account-setup'),
);

type Props = {
  className?: string;
  ctaText: string;
};

function CompleteMySetupCta({ ctaText, className }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isEligibleForFinishAccountSetup = useAppSelector(
    selectIsEligibleForFinishAccountSetup,
  );
  const ctaClassName = clsx(styles.compleMySetupCta, className);

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <If condition={isEligibleForFinishAccountSetup}>
      <Button
        type='link'
        className={ctaClassName}
        onClick={handleModalOpen}
        data-qa-selector={QaCreditCardCapture.buttonCompleteSetup}
      >
        {ctaText}
      </Button>
      <If condition={isModalOpen}>
        <Suspense fallback={<Spin fullscreen />}>
          <FinishAccountSetupModal
            isOpen
            step={1}
            handleClose={handleModalClose}
          />
        </Suspense>
      </If>
    </If>
  );
}

export default CompleteMySetupCta;
